import { PromotionType } from "@omni/types/api/product/bff/shared/enums/promotionType.enum";
import { Promotion } from "@omni/types/api/product/bff/shared/promotion.model";
import { Translate } from "@omni/types/utils/translate";
import { isDefined } from "@omni/utils/helper.utils";

import { DisplayPromotion } from "@/components/Product/ECommerce/eCommerce.types";
import { safeParseISO } from "@/utils/date";

const BLACK_LAST = [PromotionType.GratisTransportkost, PromotionType.Cashback];

const filterPromotions = (promotion: Promotion) => {
    return (
        !!promotion.marketingText &&
        !!promotion.promotionType &&
        !BLACK_LAST.find((bl) => bl === promotion.promotionType)
    );
};

const PromotionEnhancer = (
    promotions: Promotion[],
    isDoubleBonusPoints: boolean,
    t: Translate
) => {
    const enhancedPromotions =
        Object.values(
            promotions
                ?.filter(filterPromotions)
                .reduce<Record<string, Array<DisplayPromotion>>>(
                    (acc, prom) => {
                        const key = `${prom.marketingText}-${prom.promotionType}`;
                        const promotion = {
                            marketingText: prom.marketingText ?? undefined,
                            validFrom: safeParseISO(prom.validFrom),
                            validTo: safeParseISO(prom.validTo),
                            periodText: prom.periodText ?? undefined
                        };

                        if (acc[key]) {
                            acc[key].push(promotion);
                        } else {
                            acc[key] = [promotion];
                        }

                        return acc;
                    },
                    {}
                ) || {}
        ).reduce<Array<DisplayPromotion>>((acc, groupedPromList) => {
            const oldestValidToPromotion = groupedPromList
                .filter(isDefined)
                .sort((a, b) => {
                    // Sort by validTo date, descending
                    // If validTo is not present, it should be last
                    const aDate = a.validTo?.getTime() ?? 0;
                    const bDate = b.validTo?.getTime() ?? 0;
                    return bDate - aDate;
                })
                .at(0);

            if (oldestValidToPromotion) {
                acc.push(oldestValidToPromotion);
            }

            return acc;
        }, []) || [];

    if (isDoubleBonusPoints) {
        enhancedPromotions.push({
            marketingText: t("productDetail.promo.doubleBonusPoints"),
            validFrom: undefined,
            validTo: undefined
        });
    }

    return enhancedPromotions;
};

export { PromotionEnhancer };
